import React from "react";
import { useAppSelector } from "@/app/lib/hooks";
import ReactHtmlParser from "react-html-parser";

interface ItineraryItem {
  id: number;
  title: string;
  description: string;
  order: number;
}

const ItinerariesH: React.FC = () => {
  const tour = useAppSelector((state) => state.tour.tourDetails);

  const itineraries: ItineraryItem[] =
    tour?.itineraries?.map((itinerary: any, index: number) => ({
      id: itinerary.id,
      title: itinerary.entry?.data?.[0]?.title || "",
      description: itinerary.entry?.data?.[0]?.content || "",
      order: itinerary.order ?? index,
    })) || [];

  const sorted = [...itineraries].sort((a, b) => a.order - b.order);

  return (
    <div>
      {sorted.map((item, index) => {
        const last = index === sorted.length - 1;
        return (
          <div
            key={item.id ?? index}
            className="flex gap-4"
            style={{
              paddingBottom: 16,
              marginBottom: last ? 0 : 16,
              borderBottom: last ? "none" : "1px dashed var(--g-line)",
            }}
          >
            <div
              className="grid place-items-center flex-shrink-0"
              style={{
                width: 28,
                height: 28,
                borderRadius: "50%",
                background: "var(--g-burgundy)",
                color: "white",
                fontSize: 12,
                fontWeight: 800,
              }}
              aria-hidden="true"
            >
              {index + 1}
            </div>
            <div className="min-w-0">
              <h3
                className="font-bold mb-1"
                style={{ color: "var(--g-burgundy)", fontSize: 15, lineHeight: 1.25 }}
              >
                {item.title}
              </h3>
              <div
                className="tour-content"
                style={{ color: "var(--g-burgundy)", opacity: 0.8, fontSize: 14, lineHeight: 1.55 }}
              >
                {ReactHtmlParser(item.description)}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ItinerariesH;
